import { connect } from 'react-redux';
import App from '../App'

export default connect(
state => ({
    isDayMode: state.isDayMode
}),
dispatch => ({  
   
})
)(App)